import React from 'react'

import { ProductApi } from '../../api/product_api';

import MUIDataTable from "mui-datatables";
import NumberFormat from 'react-number-format';
import Divider from '@material-ui/core/Divider';
import SearchIcon from '@material-ui/icons/Search'
import TextField from '@material-ui/core/TextField';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Notification from '../Notifications'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';


import { ADMIN_ROLE } from '../../constants'
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/user';
import { bindActionCreators } from 'redux';


const options = {
    selectedRows: {
        text: "fila(s) seleccionada",
        delete: "Delete",
        deleteAria: "Desactivar combo"
    },
    downloadOptions: {
        filename: 'Catalogo de Combos.csv',
        separator: ','
    },
    textLabels: {
        body: {
            noMatch: "No hay Combos en catalogo",
            toolTip: "Sort",
        },
        pagination: {
            next: "Siguiente pag",
            previous: "Anterior",
            rowsPerPage: "Filas por pagina:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabla",
        },
        selectedRows: {
            text: "fila(s) seleccionadas",
            delete: "Desactivar",
            deleteAria: "Desactivar combo(s)",
          },
    
    },

}
const customStyles = {
    top: `30%`,
    margin: 'auto',
    width: 300,
    height: 400,
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};


function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}

const percentageLimit = (val)=> {
    if(val === 0){
        val = 1
    }else if(val >1000){
        val = 1000
    }else if(val < -1000){
        val = -1000
    }
    return val
}
function PercentageFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: percentageLimit(values.value),
                    },
                });
            }}
            decimalScale={2}
            allowNegative={true}
            thousandSeparator={'.'}
            decimalSeparator={','}
            suffix="%"
        />
    );
}


function mapStateToProps(state) {
    return {
        userRoles: state.user.userRoles

    };
}

function mapDispatchToProps(dispatch) {
    return {}
}


const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
};

@connect(mapStateToProps, mapDispatchToProps)
export class ComboView extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            codeProd: '',
            prodsToCombo: [],
            prodsToComboFinal: [],
            showMsg: false,
            msgType: null,
            msg: null,
            price: null,
            descripcion: null,
            columns: [{ name: "Codigo", options: { filter: false } },
            { name: "Status", options: { 
                print: false, 
                filterType: 'dropdown',
                filterList: ['Activo'],
                }
            },
            { name: "Nombre", options: { filter: false } },
            { name: "Precio", options: { 
                                display: true,
                                filter: false,
                                customBodyRender: value => <NumberFormat
                                    value={value}
                                    displayType={'text'}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    prefix="$"
                                />
                
                    
                }},
            { name: "Productos", options: { filter: false } },
            
            ],
            
            title: "Catalogo de Combos",
            comboCatalog: [],
            isLoading: true,
            targetCombos: [],
            
        }
        options['onRowsDelete'] = this.deactivateCombos,
        options['onRowsSelect'] = this.appendCheckedList
    }

    deactivateCombos = (rowsDeleted) =>{
        const deleteCombos = rowsDeleted.data.map((data) => {
            return {'id': this.state.comboCatalog[data.dataIndex][0], 'active': this.state.comboCatalog[data.dataIndex][1] == 'Inactivo'}
        });
        const data = {combos: deleteCombos}
        ProductApi.updateCombos(data)
        .then( response =>{
            this.setState({showMsg: true, msgType: 'success', msg:'Combos modificados'})
            this.fetchComboCatalog()
        })
        .catch(error =>{
            console.log(error)
            this.setState({showMsg: true, msgType: 'error', msg:'No se pudo realizar la operacion'})
            
        })

    }
    componentDidMount = () =>{
        this.fetchComboCatalog()
    }
    fetchComboCatalog = () =>{
        ProductApi.getComboReport()
        .then((response) => {
            let rows = []
            response.data.map(function (combo) {
                const active = combo.active?'Activo':'Inactivo';
                let products = combo.items.map(function (item) {
                    return (<div>
                    <Typography display="inline">
                    <b>Cod: </b>{item.product.id} - {item.product.type}  {item.product.brand} {item.product.model}
                    </Typography>
                    <Typography>
                    <b>Cantidad: </b> {item.units} 
                    </Typography>
                    </div>)
                })
                rows.push([combo.id, active, combo.brand + '  ' + combo.model, combo.price, products])
            })
            return rows
        })
        .then((data) => {
            this.setState({ comboCatalog: data, isLoading: false })
        })
    }

    createCombo = () => {
        if (this.state.price == null || this.state.price == 0) {
            this.setState({ showMsg: true, msg: 'Indicar precio', msgType: 'error' })
            return
        }
        if (this.state.descripcion == null || this.state.descripcion == '') {
            this.setState({ showMsg: true, msg: 'Indicar nombre del combo', msgType: 'error' })
            return
        }
        const combo = { brand: 'Lisboa', model: this.state.descripcion, price: this.state.price, products: this.state.prodsToComboFinal }
        ProductApi.createCombo(combo)
            .then(response => {
                this.setState({
                    showMsg: true, msg: 'Combo creado', msgType: 'success',
                    prodsToCombo: [], prodsToComboFinal: [], price: null, codeProd: ''
                })
                fetchComboCatalog()
            })
            .catch(error => {
                this.setState({ showMsg: true, msg: error.response.data.message, msgType: 'error' })
            })

    }

    setProdToCombo = (prod_id, quantity) => {
        let temp = this.state.prodsToComboFinal
        let elm = temp.find(element => element.id == prod_id);
        elm.units = quantity
        this.setState({ prodsToComboFinal: temp })
    }
    loadProducts = () => {
        return (<div className='col-md-7'><Table>
            <TableHead>
                <TableRow>
                    <TableCell><b>Codigo</b></TableCell>
                    <TableCell><b>Producto</b></TableCell>
                    <TableCell align="right"><b>Precio</b></TableCell>
                    <TableCell align="right" ><b>Cantidad</b></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {this.state.prodsToCombo.map((product) => (
                    <TableRow key={product.id}>
                        <TableCell>{product.id}</TableCell>
                        <TableCell>{product.descripcion} </TableCell>
                        <TableCell align="right">
                            <NumberFormat
                                value={product.price}
                                displayType={'text'}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                prefix="$"
                            />
                        </TableCell>
                        <TableCell align="right" style={{ width: '20%' }}>
                            <TextField style={{ marginLeft: 30, marginTop: -20 }}
                                type="number"
                                InputProps={{
                                    inputProps: {
                                        min: 1
                                    }
                                }}
                                prodId={product.id}
                                defaultValue={1}
                                onChange={(e) => this.setProdToCombo(product.id, e.target.value)}
                            />
                        </TableCell>
                    </TableRow>

                ))}

            </TableBody>

        </Table></div>
        )
    }
    switch = (e) => {
        this.setState({percentage: !this.state.percentage, amount:0})
    }


    handleNotificationClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ showMsg: false });
    }

    searchProduct = e => {
        if (e.keyCode == null || e.keyCode == 13) {
            ProductApi.get(this.state.codeProd)
                .then((response) => {
                    let prod = response.data.product
                    if (prod.active == false) {
                        this.setState({ showMsg: true, msgType: 'error', msg: 'Producto desactivado!' })
                        return
                    }
                    const found = this.state.prodsToComboFinal.find(element => element.id == prod.id);
                    if (found) {
                        this.setState({ showMsg: true, msgType: 'info', msg: 'El producto ya esta agregado' })
                        return
                    }
                    const newProd = { id: prod.id, descripcion: prod.brand + ' ' + prod.model, quantity: 1, price: prod.price }
                    let prodsToCombo = this.state.prodsToCombo
                    prodsToCombo.push(newProd)
                    let prodsToComboFinal = this.state.prodsToComboFinal
                    prodsToComboFinal.push({ id: prod.id, units: 1 })
                    this.setState({ prodsToCombo: prodsToCombo, prodsToComboFinal: prodsToComboFinal });
                }
                )
                .catch(error => {
                    this.setState({ open: true, details: false });
                })

        }
        else if (!isNaN(e.key)) {
            this.setState({ codeProd: this.state.codeProd + e.key })
        }
        else if (e.keyCode == 8) {
            const prod = this.state.codeProd.slice(0, this.state.codeProd.length - 1)
            this.setState({ codeProd: prod })
        }

    }
    appendCheckedList = (_, allRowsSelected) => {
        
        const tempTargetCombos = allRowsSelected.map((data) => {
            const combo =  this.state.comboCatalog[data.dataIndex];
            return  {'id': combo[0], 'price': combo[3]}
        })
        this.setState({ targetCombos: tempTargetCombos })

    }
    setPrice = (e) =>{
        if(event.target.value != null){
            this.setState({price: parseFloat(e.target.value)})
        }
        
    }
    setAmount= (e) =>{
        if(this.state.percentage && (e.target.value == null || parseFloat(e.target.value) > 1000 || parseFloat(e.target.value) < - 99)){
            this.setState({amount: this.state.amount})
        }
        else if(e.target.value != null ){
            this.setState({amount: parseFloat(e.target.value)})
        }
        
    }
    canModify = (inUpdate) => {
        if(inUpdate){
            return false;
        }
        if(this.state.amount == 0 || this.state.amount == '' || this.state.amount == null || isNaN(this.state.amount)){
            return false
        }
        if(this.state.targetCombos.length == 0){
            return false
        }
        return true
    }
    updateComboCatalog = () =>{
        let isValid = true
        if(this.state.percentage){
            this.state.targetCombos.map(combo =>{
                combo.price = _.round( combo.price + (combo.price * this.state.amount) / 100,2)
                if(combo.price <=0 ){
                    this.setState({showMsg: true, msgType: 'error', msg:'precio invalido'})
                    isValid = false
                }
            })
        }
        else{
            this.state.targetCombos.map(combo =>{
                combo.price = _.round( combo.price + this.state.amount, 2)
                if(combo.price <=0 ){
                    this.setState({showMsg: true, msgType: 'error', msg:'precio invalido'})
                    isValid = false
                }
            })
        }
        if(isValid){
            ProductApi.updateCombos({'combos': this.state.targetCombos})
            .then(response=>{
                this.setState({showMsg: true, msgType: 'success', msg:'Combos actualizados', amount:0, targetCombos:[]})
                this.fetchComboCatalog()
            })
            .catch(error =>{
                console.log(error)
                this.setState({showMsg: true, msgType: 'error', msg:'Algo salio mal'})
            })
        }
        
    }

    loadCombos = () => {
        const isAdmin = this.props.userRoles.includes(ADMIN_ROLE)
        return (
            <div>
            <div style={{ marginTop: 30 }}>
                <MUIDataTable
                    title={this.state.title}
                    data={this.state.comboCatalog}
                    columns={this.state.columns}
                    options={options}
                />
            </div>
            {isAdmin && <form role="form">

             <FormGroup row >
                 <FormControl component="fieldset">
                     <RadioGroup aria-label="position" name="position"
                         value={this.state.percentage ? "%" : "$"}
                         onChange={this.creditCycle} row>
                         <FormControlLabel
                             control={
                                 <Switch
                                     checked={this.state.percentage}
                                     onChange={this.switch}
                                     color="primary"
 
                                 />
                             }
                                 label='Porcentual'
                         />


                     </RadioGroup>
                 </FormControl>
             </FormGroup>
             
             <div className='col-md-4'>
             <FormGroup row>
             
             <TextField
                     label={this.state.percentage?"Porcentaje":"Monto"}
                     value={this.state.amount}
                     onChange={this.setAmount}
                     id="amount"
                     InputProps={{
                         inputComponent: this.state.percentage?PercentageFormatCustom:NumberFormatCustom,
                     }}
                 />
                 
             </FormGroup>
             </div>
             
                 <FormGroup row>
                 <Button
                     variant="contained"
                     color="primary"
                     onClick={(e) => this.updateComboCatalog(e)}
                     disabled={!this.canModify()}
                 >
                     Modificar
                 </Button>
                 
             </FormGroup>
         </form>}
         </div>
        )
    }
    render = () => {
        return (<div>
            <div className="col-md-12" style={{ marginTop: 20 }}>
                <Typography variant="h5" gutterBottom>
                    Generar nuevo combo
                </Typography>
                <InputBase
                    autoFocus='autoFocus'
                    placeholder="producto a incluir"
                    value={this.state.codeProd}
                    onKeyDown={this.searchProduct} />
                <IconButton aria-label="Search"
                    onClick={this.searchProduct}>
                    <SearchIcon />
                </IconButton>


                {this.state.showMsg && <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleNotificationClose}
                />}
                <Divider />

            </div>
            <div>
                {this.state.prodsToCombo.length > 0 && this.loadProducts()}
                <Divider />
                <br/>
                <br/>
                {this.state.prodsToCombo.length > 0 && <div className='col-md-12'>
                    
                    <TextField
                            label="Precio"
                            value={this.state.price}
                            onChange={this.setPrice}
                            id="price"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                        />
                        
                    <TextField
                        style={{ marginLeft: 30 }}
                        label="Nombre del combo"
                        onChange={(e) => this.setState({ descripcion: e.target.value })}
                        onInput={toInputUppercase}
                        type='text'
                        value={this.state.descripcion}
                    />
                </div>}

                {this.state.prodsToCombo.length > 0 && <div className="col-md-12">
                    <Button
                        onClick={this.createCombo}
                        variant="contained"
                        color="primary"
                    >

                        Crear Combo
                    </Button>
                </div>}
            </div>
            <br/>
            <br/>
            <Divider />
            <div className="col-md-12" style={{ marginTop: 20 }}>
                <Typography variant="h5" gutterBottom>
                    Combos existentes
                </Typography>
                {this.state.isLoading
                    ? <div style={{ marginTop: 70 }} className="col-md-6 col-md-offset-5">
                        <CircularProgress
                            size={80}
                            color='primary'
                            thickness={3}
                            style={{ display: 'center' }} />
                    </div>
                    : <div>{this.loadCombos()}</div>
                }
            </div>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Products/Combo.js